import { useStore } from '@/store';
import { BuildColorAndIcon, isLandingPage } from '@/modules/gem-meter';
import usePlanPermission from '@modules/common/composable/usePlanPermission';
import { useGoToPricing } from '@/modules/editor-sidebar/hooks/useGoToPricing';

const notiAssignedProduct = () => {
  return (
    "<div id='noti-assigned' class='noti p-2 d-flex align-items-start'><i class='icon mr-1 icon-infor-circle-fill'></i>" +
    "<div class='d-flex justify-content-between flex-grow-1 align-items-center'><p class='noti__content-desc paragraph-14-regular text-lightmode noti__content-desc--info'>" +
    'The assigned product will be displayed with this layout' +
    "</p></div><i data-id='assigned' class='close-nofi-assign icon icon-close'></i>" +
    '</div>'
  );
};

const notiNoAssignedProduct = () => {
  return (
    "<div id='noti-noassign' class='noti p-2 d-flex align-items-start'><i class='icon mr-1 icon-infor-circle-fill'></i>" +
    "<div class='d-flex justify-content-between flex-grow-1 align-items-center'><p class='noti__content-desc paragraph-14-regular text-lightmode noti__content-desc--info'>" +
    'Don&apos;t forget to assign product before publish this page' +
    "</p></div><i data-id='noassign' class='close-nofi-assign icon icon-close'></i>" +
    '</div>'
  );
};

/**
 * templateLoading
 * @returns {String} ..
 */
export const templateLoading = () =>
  '<div class="confirm_publish_loading">' +
  '<div class="gfLoader-frame">' +
  '<div class="gfLoader-Circle">' +
  '<svg class="gfLoader-Circle-shape" viewBox="25 25 50 50">' +
  '<circle class="gfLoader-Circle-track" cx="50" cy="50" r="23" fill="none" stroke-width="1.5" stroke-miterlimit="10" stroke="rgba(10,10,58,0.1)"/>' +
  '<circle class="gfLoader-Circle-path" cx="50" cy="50" r="23" fill="none" stroke-width="1.5" stroke-miterlimit="10"/>' +
  '</svg>' +
  '</div>' +
  '<div class="gfLoader-ColorfulLogo">' +
  '<svg class="gfLoader-ColorfulLogo-shape" viewBox="0 0 28 28">' +
  '<path d="M26.7,2c0.1,0,0.1,0,0.2,0s0.1,0.1,0,0.2c-0.7,2.1-1.6,4.2-2.6,6.2 c-0.4,0.7-1.1,1.3-1.9,1.6L5.1,15.2c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1L3,9.3c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1L26.7,2z M21.2,12.2c0.1,0,0.1,0,0.2,0s0.1,0.1,0,0.2c-0.6,1.8-1.3,3.6-2.2,5.2c-0.3,0.6-0.9,1.1-1.6,1.3l-9.3,2.8c-0.1,0-0.2,0-0.2-0.1 l-1.5-4.9c0-0.1,0-0.2,0.1-0.2L21.2,12.2z M15.1,21.3c0,0,0.1,0,0.1,0s0,0.1,0,0.1c-0.5,1.5-1.1,3-1.9,4.4c-0.3,0.5-0.8,0.9-1.4,1.1 l-0.8,0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1L9.7,23c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1L15.1,21.3z"/>' +
  '</svg>' +
  '</div>' +
  '</div>' +
  '</div>';

/**
 * template fake publish
 * @param text {String}
 * @returns {String} ...
 */
export const templateFakePublish = (text: string) =>
  '<div class="fake_publish btn btn-primary">' +
  '<a>' +
  '<span>' +
  `<span class="publish_text">${text}</span>` +
  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-ab429b64=""><path d="M4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645L10 12.2929L14.6464 7.64645C14.8417 7.45118 15.1583 7.45118 15.3536 7.64645C15.5488 7.84171 15.5488 8.15829 15.3536 8.35355L10.3536 13.3536C10.1583 13.5488 9.84171 13.5488 9.64645 13.3536L4.64645 8.35355C4.45118 8.15829 4.45118 7.84171 4.64645 7.64645Z" fill="white" data-v-ab429b64=""></path></svg>' +
  '</span>' +
  '</a>' +
  '</div>';

/**
 * template fake publish
 * @param campaignLink {String}
 * @returns {String} ...
 */
export const templateCampaignRunning = (campaignLink: string) =>
  '<div class="campaing_running d-flex align-items-center justify-content-center mb-2">' +
  '<label class="typo-button14 typo-medium text-light-high typo-lh-150 text-center">' +
  `You can't publish this template because this template is linked to <a href="${campaignLink}" target="_blank">a running campaign</a>` +
  '</label>' +
  '</div>';

/**
 * templateConfirmMakeDefault
 * @param textBtnYes ...
 * @returns {String} ..
 */
export const templateConfirmMakeDefault = (textBtnYes = 'Make Default') =>
  '<div class="confirm_makeDefault">' +
  '<div class="confirm_makeDefault_body">' +
  '<div class="confirm_makeDefault_header p-4 pb-2">' +
  '<h3 class="text-light-high typo-h20">Are you sure?</h3>' +
  '</div>' +
  '<div class="confirm_makeDefault_content py-3 px-4">' +
  '<div class="confirm_makeDefault_message typo-p14 typo-regular typo-lh-150 text-light-low"></div>' +
  '</div>' +
  '<div class="confirm_makeDefault_footer p-4 pt-0 d-flex align-items-center justify-content-end">' +
  `<button class="yes btn btn-success btn-default px-2 mr-1">${textBtnYes}</button>` +
  `<button class="no btn btn-outline btn-default px-2 btn-clean">${
    textBtnYes == 'Make Default' ? 'Cancel' : 'No'
  }</button>` +
  '</div>' +
  '</div>' +
  '</div>';

type TemplateSubpageParams = {
  fakePublishText: string;
  title: string;
  handle: string;
  meta: Array<unknown>;
  btnText: string;
  campaignLink: string;
};

/**
 * templateSubpage
 * @param args {TemplateSubpageParams} ..
 * @returns {String} ./.
 */
export const templateSubpage = (args: TemplateSubpageParams, refDegProgress: number) => {
  const { isTrialExpired, limitedPublished } = usePlanPermission();
  const { fakePublishText, title, handle, meta, btnText, campaignLink } = args;

  let warnCampaign = '',
    hasCampaign = '';
  if (campaignLink && campaignLink.length) {
    hasCampaign = 'disabled="disabled"';
    warnCampaign = templateCampaignRunning(campaignLink);
  }

  if (isTrialExpired.value || limitedPublished.value) {
    hasCampaign = 'disabled="disabled"';
  }

  if (isTrialExpired.value || limitedPublished.value) {
    return (
      '<div class="body_confirm_publish">' +
      templateFakePublish(fakePublishText) +
      '<div class="confirm_publish !p-4 !bg-white">' +
      '<div class="confirm_publish_group">' +
      '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
      `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
      '</div>' +
      '<div class="confirm_publish_group">' +
      templateLazyLoading() +
      '</div>' +
      templateReachLimitPublic() +
      templateButtonPublicPage(hasCampaign, btnText, '') +
      '</div>'
    );
  }

  return (
    '<div class="body_confirm_publish">' +
    templateFakePublish(fakePublishText) +
    '<div class="confirm_publish !p-4 !bg-white">' +
    '<div class="confirm_publish_group">' +
    warningConfirmPassword() +
    '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
    `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
    '</div>' +
    '<div class="confirm_publish_group">' +
    '<label class="typo-button14 typo-medium text-light-high">URL and Handle</label>' +
    `<input class="!border-light-500" class="model" type="text" name="handle" value="${handle}" />` +
    '</div>' +
    '<span class="error_handle"></span>' +
    '<div class="confirm_publish_group">' +
    `<label class="typo-button14 typo-medium text-light-high">Meta Description<span class="count_desc typo-p10"><span class="count_desc_value">${meta.length}</span>/320</span></label>` +
    `<textarea class="model !border-light-500" type="text" name="desc">${meta}</textarea>` +
    templateLazyLoading() +
    '</div>' +
    warnCampaign +
    templateReachLimitPublic() +
    templateButtonPublicPage(hasCampaign, btnText, '') +
    templateGemMeterProgressBar(refDegProgress) +
    templateLoading() +
    '</div>'
  );
};

type TemplateArticlePageParams = {
  fakePublishText: string;
  title: string;
  handle: string;
  meta: Array<unknown>;
  btnText: string;
  campaignLink: string;
};

/**
 * templateSubpage
 * @param args {TemplateArticlePageParams} ..
 * @returns {String} ./.
 */
export const templateArticlePage = (args: TemplateArticlePageParams) => {
  const { fakePublishText, title, handle, meta, btnText, campaignLink } = args;
  let warnCampaign = '',
    hasCampaign = '';
  if (campaignLink && campaignLink.length) {
    hasCampaign = 'disabled="disabled"';
    warnCampaign = templateCampaignRunning(campaignLink);
  }
  const { isTrialExpired, limitedPublished } = usePlanPermission();
  if (isTrialExpired.value || limitedPublished.value) {
    hasCampaign = 'disabled="disabled"';
  }
  return (
    '<div class="body_confirm_publish">' +
    templateFakePublish(fakePublishText) +
    '<div class="confirm_publish !p-4 !bg-white">' +
    '<div class="confirm_publish_group">' +
    warningConfirmPassword() +
    '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
    `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
    '</div>' +
    '<div class="confirm_publish_group">' +
    '<label class="typo-button14 typo-medium text-light-high">URL and Handle</label>' +
    `<input class="model !border-light-500" type="text" name="handle" value="${handle}" />` +
    '</div>' +
    '<span class="error_handle"></span>' +
    '<div class="confirm_publish_group">' +
    `<label class="typo-button14 typo-medium text-light-high">Meta Description<span class="count_desc typo-p10"><span class="count_desc_value">${meta.length}</span>/320</span></label>` +
    `<textarea class="model !border-light-500" type="text" name="desc" >${meta}</textarea>` +
    templateLazyLoading() +
    '</div>' +
    warnCampaign +
    templateReachLimitPublic() +
    templateButtonPublicPage(hasCampaign, btnText, '') +
    '</div>' +
    templateLoading() +
    '</div>'
  );
};

type TemplateCollectionPageParams = {
  fakePublishText: string;
  title: string;
  publishBtn: {
    text: string;
    class: string;
  };
  confirmText: string;
  campaignLink: string;
};

/**
 * templateCollectionPage
 * @param args {TemplateCollectionPageParams} ..
 * @returns {String} ./.
 */
export const templateCollectionPage = (args: TemplateCollectionPageParams) => {
  const { fakePublishText, title, publishBtn, confirmText, campaignLink } = args;

  let warnCampaign = '',
    hasCampaign = '';
  if (campaignLink && campaignLink.length) {
    hasCampaign = 'disabled="disabled"';
    warnCampaign = templateCampaignRunning(campaignLink);
  }
  const { isTrialExpired, limitedPublished } = usePlanPermission();
  if (isTrialExpired.value || limitedPublished.value) {
    hasCampaign = 'disabled="disabled"';
  }

  return (
    '<div class="body_confirm_publish">' +
    templateFakePublish(fakePublishText) +
    '<div class="confirm_publish !p-4 !bg-white">' +
    '<div class="confirm_publish_group">' +
    warningConfirmPassword() +
    '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
    `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
    templateLazyLoading() +
    '</div>' +
    warnCampaign +
    templateReachLimitPublic() +
    templateButtonPublicPage(hasCampaign, publishBtn.text, publishBtn.class) +
    '</div>' +
    templateConfirmMakeDefault(confirmText) +
    templateLoading() +
    '</div>'
  );
};
type TemplateProductPageParams = {
  fakePublishText: string;
  title: string;
  publishBtn: {
    text: string;
    class: string;
  };
  confirmText: string;
  campaignLink: string;
  pAssigned: boolean;
  gId?: any;
};

/**
 * templateProductPage
 * @param args {TemplateProductPageParams} ..
 * @returns {String} ./.
 */
export const templateProductPage = (args: TemplateProductPageParams) => {
  const { fakePublishText, title, publishBtn, confirmText, campaignLink, pAssigned, gId } = args;
  let warnCampaign = '',
    hasCampaign = '';
  if (campaignLink && campaignLink.length) {
    hasCampaign = 'disabled="disabled"';
    warnCampaign = templateCampaignRunning(campaignLink);
  }
  const { isTrialExpired, limitedPublished } = usePlanPermission();
  if (isTrialExpired.value || limitedPublished.value) {
    hasCampaign = 'disabled="disabled"';
  }

  let messagePublish = '';
  const hideWarningPublishPopup = localStorage.getItem('hideWarningPublishPopup')
    ? JSON.parse((localStorage as any).getItem('hideWarningPublishPopup'))
    : {};
  if (pAssigned) {
    if (!hideWarningPublishPopup[gId] || !hideWarningPublishPopup[gId]['assigned']) {
      messagePublish = notiAssignedProduct();
    }
  } else {
    if (!hideWarningPublishPopup[gId] || !hideWarningPublishPopup[gId]['noassign']) {
      messagePublish = notiNoAssignedProduct();
    }
  }

  return (
    '<div class="body_confirm_publish">' +
    templateFakePublish(fakePublishText) +
    '<div class="confirm_publish !p-4 !bg-white">' +
    messagePublish +
    '<div class="confirm_publish_group">' +
    warningConfirmPassword() +
    '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
    `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
    templateLazyLoading() +
    '</div>' +
    warnCampaign +
    templateReachLimitPublic() +
    templateButtonPublicPage(hasCampaign, publishBtn.text, publishBtn.class) +
    '</div>' +
    templateConfirmMakeDefault(confirmText) +
    templateLoading() +
    '</div>'
  );
};

type TemplateHomePageParams = {
  fakePublishText: string;
  title: string;
  publishBtn: {
    text: string;
    class: string;
  };
  confirmText: string;
  campaignLink: string;
};

// ===== GemMeter Feature ===== //
export const templateGemMeterProgressBar = (degProgressValue: any) => {
  if (!isLandingPage()) {
    return '';
  }

  const { style, label } = BuildColorAndIcon(degProgressValue);
  const pageElements = useStore().state.gemMeter.pageElements;
  if (Object.values(pageElements).length == 0 || degProgressValue >= 360) {
    return '';
  }

  const cloneIcon = `<img src="/editor/static/gemmeter/icons/onboarding-status.svg" />`;

  return `
    <div class="meter !mb-5" id="gemeter-arrow">
      <div class="flex bg-[#E3E6F2] hover:bg-blue-100 p-[12px] rounded border border-blue-300 !mt-3 cursor-pointer">
        <div style="--progress: ${style['--progress']}; background: ${style.background}" class="bg-light-100 rounded-[50%] relative flex items-center justify-center max-h-[60px] max-w-[60px] !mr-3">
          <div class="bg-light-100 w-[52px] h-[52px] absolute rounded-[50%]"></div>
          <div class="z-10 h-[60px] w-[60px] flex items-center justify-center">
            ${cloneIcon}
          </div>
        </div>
        <div class="flex flex-wrap">
          <h4 class="text-text_light_mode-high_contrast text-base font-semibold">
            ${label}
          </h4>
          <div class="flex">
            <div class="text-blue-300 font-medium text-xs !mr-2">
                Let’s make it better
            </div>
            <svg class="arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.1475 11.7858C9.9515 11.9759 9.63371 11.9759 9.43771 11.7858C9.2417 11.5957 9.2417 11.2875 9.43771 11.0975L12.1162 8.5L2.55195 8.5C2.28174 8.5 2.0627 8.27615 2.0627 8C2.0627 7.72386 2.28174 7.5 2.55195 7.5L12.1162 7.5L9.43771 4.9025C9.2417 4.71243 9.2417 4.40425 9.43771 4.21418C9.63371 4.0241 9.9515 4.0241 10.1475 4.21418L13.6965 7.65582C13.8925 7.84589 13.8925 8.15407 13.6965 8.34415L10.1475 11.7858Z" fill="#3C67FF"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  `;
  // const { color } = BuildColorAndIcon(degProgressValue);
  // const { group, screenType } = useGemMeter();
  // const isBlankPage = useStore().state.editor.isBlankPage;

  // if (isBlankPage || degProgressValue === 100 || !group.value || !group.value[0]) {
  //   return '';
  // }

  // const firstErrorGroup = group.value[0];
  // //@ts-ignore
  // if (!CHECK_LIST[firstErrorGroup.key]) {
  //   return '';
  // }

  // //@ts-ignore
  // const ruleData = CHECK_LIST[firstErrorGroup.key];
  // const errorLength = Object.values(firstErrorGroup.screen[screenType.value].errorElements).filter((item) => item.visible).length;
  // const priorityColor = ruleData.priority === PRIORITY.CRITICAL
  //   ? 'text-red-300 bg-red-100'
  //   : ruleData.priority === PRIORITY.HIGH
  //     ? 'text-amber-500 bg-amber-100'
  //     : 'text-green-500 bg-green-100'

  // let errorCount = '';
  // if (!ruleData.isPageRule) {
  //   errorCount = `
  //     <p class="px-1 py-0 text-[10px] text-light-100 font-medium leading-3 rounded-md inline-block bg-red-300">
  //       ${errorLength}
  //     </p>
  //   `
  // }

  // return `
  //   <div class="bg-light-100 rounded-[3px] !p-3 flex items-start !mb-4">
  //     <div
  //       class="h-10 w-10 bg-light-100 rounded-full flex items-center justify-center !mr-3"
  //       style="filter: drop-shadow(0px -1.33333px 5.33333px rgba(0, 0, 0, 0.06)) drop-shadow(0px 1.33333px 5.33333px rgba(0, 0, 0, 0.12))"
  //     >
  //       <div
  //         class="w-[38px] h-[38px] rounded-full flex items-center justify-center"
  //         style="background: conic-gradient(${color} ${degProgressValue}deg,#fff 0deg)"
  //       >
  //         <div class="w-8 h-8 rounded-full bg-light-100 flex items-center justify-center">
  //           <img src="/editor/static/gemmeter/icons/onboarding-status.svg" width="20px" height="20px" />
  //         </div>
  //       </div>
  //     </div>
  //     <div class="leading-none">
  //       <p class="!mb-2 py-[1px] px-2 rounded-[3px] font-medium text-xs leading-[14px] inline-block ${priorityColor}">
  //         <span class="capitalize">${ruleData.priority}</span> impact
  //       </p>
  //       <div class="flex items-center !mb-1">
  //         <p class="text-light-mode-high-contrast font-semibold text-sm leading-4 !mr-1">
  //           ${ruleData.title}
  //         </p>
  //         ${errorCount}
  //       </div>
  //       <p class="text-light-mode-low-contrast text-sm leading-[22px] !mb-2">${ruleData.description}</p>
  //       <p id="gem-meter-show" class="text-blue-300 cursor-pointer text-sm leading-5 font-medium flex items-center">
  //         Show this issue
  //         <i class="icon icon-back text-xl !ml-1 rotate-180 leading-none" />
  //       </p>
  //     </div>
  //   </div>
  // `
};
// =========================== //

/**
 * templateHomePage
 * @param args {TemplateHomePageParams} ..
 * @returns {String} ./.
 */
export const templateHomePage = (args: TemplateHomePageParams) => {
  const { fakePublishText, title, publishBtn, confirmText, campaignLink } = args;
  let warnCampaign = '',
    hasCampaign = '';
  if (campaignLink && campaignLink.length) {
    hasCampaign = 'disabled="disabled"';
    warnCampaign = templateCampaignRunning(campaignLink);
  }
  const { isTrialExpired, limitedPublished } = usePlanPermission();
  if (isTrialExpired.value || limitedPublished.value) {
    hasCampaign = 'disabled="disabled"';
  }
  return (
    '<div class="body_confirm_publish">' +
    templateFakePublish(fakePublishText) +
    '<div class="confirm_publish !p-4 !bg-white">' +
    '<div class="confirm_publish_group">' +
    warningConfirmPassword() +
    '<label class="typo-button14 typo-medium text-light-high">Template Name</label>' +
    `<input class="model !border-light-500" type="text" name="title" value="${title}" />` +
    templateLazyLoading() +
    '</div>' +
    warnCampaign +
    templateReachLimitPublic() +
    templateButtonPublicPage(hasCampaign, publishBtn.text, publishBtn.class) +
    '</div>' +
    templateConfirmMakeDefault(confirmText) +
    templateLoading() +
    '</div>'
  );
};

const templateLazyLoading = () => {
  const { lazyLoadingPlanNotShow, isTrialExpired } = usePlanPermission();
  const { pricingUrl } = useGoToPricing();
  const shouldShow = `${lazyLoadingPlanNotShow.value || isTrialExpired.value ? 'show' : 'hidden'}`;

  return `<div class="lazy-load-option flex items-center">
    <label class="typo-button14 typo-medium text-light-high">
        Lazy Loading
        <span class="label-pro !bg-primary-300 !text-white font-medium ${shouldShow}">
            Build
        </span>
    </label>
    <a class="${shouldShow} text-primary-300 font-medium text-sm !pb-2 gp-open-new-tab" data-href="${pricingUrl}" target="_blank">Upgrade plan to unlock</a>
    <div class="switcher ${lazyLoadingPlanNotShow.value || isTrialExpired.value ? 'hidden' : 'show'}">
        <input id="switch-shadow" class="switch switch--shadow" type="checkbox">
        <label for="switch-shadow"></label>
    </div>
  </div>
  <div class="text-light-mode-low-contrast text-xs font-normal !pb-4 ${shouldShow}">
    Lazy loading helps you improve page loading time, enhance user experience & increase your SEO results.
    Lazy loading is available on <strong class="text-light-mode-high-contrast">Build, Optimize & Enterprise.</strong>
  </div>`;
};

const templateReachLimitPublic = () => {
  const { isTrialExpired, publishedPageInfo, limitedPublished } = usePlanPermission();
  const { pricingUrl } = useGoToPricing();

  if (isTrialExpired.value) {
    return `<div class="trial-expired-wrapper">
    <div class="reach-limit flex !p-4 !bg-blue-100 !mb-4 rounded-[3px]">
    <div class="!pt-1 !pr-2">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10ZM10.5835 5.76996C10.5835 6.11514 10.3037 6.39496 9.9585 6.39496C9.61332 6.39496 9.3335 6.11514 9.3335 5.76996C9.3335 5.42478 9.61332 5.14496 9.9585 5.14496C10.3037 5.14496 10.5835 5.42478 10.5835 5.76996ZM8.64136 6.98291C8.36521 6.98291 8.14136 7.20677 8.14136 7.48291C8.14136 7.75905 8.36521 7.98291 8.64136 7.98291H9.57507V13.1049C9.57507 13.6572 10.0228 14.1049 10.5751 14.1049H11.9643C12.2404 14.1049 12.4643 13.881 12.4643 13.6049C12.4643 13.3288 12.2404 13.1049 11.9643 13.1049H10.5751V7.98291C10.5751 7.43063 10.1274 6.98291 9.57507 6.98291H8.64136Z" fill="#2856F8"/>
      </svg>
    </div>
    <div>
      <span class="text-xs text-light-mode-high-contrast font-normal">
      Your trial has expired. You need to upgrade your plan to publish more pages.
      </span>
      <p class="text-blue-300 text-xs font-normal !mt-4">
        <a class="gp-open-new-tab" data-href="${pricingUrl}">Upgrade plan</a>
      </p>
    </div>
    </div>
    <div class="line"></div>
    </div>`;
  }

  const publishedPageAllCount = publishedPageInfo.value.publishedPage;
  const publishedPageOfType = publishedPageInfo.value.publishedPageByType;

  const limitedTextRender =
    publishedPageAllCount >= publishedPageInfo.value.limitedPublishPage
      ? `${publishedPageAllCount}/${publishedPageInfo.value.limitedPublishPage}`
      : `${publishedPageOfType || publishedPageAllCount}/${
          publishedPageInfo.value.limitedPublishPageByType || publishedPageInfo.value.limitedPublishPage
        }`;

  return `<div class="reach-limit flex !p-4 !bg-blue-100 !mb-4 ${limitedPublished.value ? '' : 'hidden'} rounded-[3px]">
    <div class="!pt-1 !pr-2">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10ZM10.5835 5.76996C10.5835 6.11514 10.3037 6.39496 9.9585 6.39496C9.61332 6.39496 9.3335 6.11514 9.3335 5.76996C9.3335 5.42478 9.61332 5.14496 9.9585 5.14496C10.3037 5.14496 10.5835 5.42478 10.5835 5.76996ZM8.64136 6.98291C8.36521 6.98291 8.14136 7.20677 8.14136 7.48291C8.14136 7.75905 8.36521 7.98291 8.64136 7.98291H9.57507V13.1049C9.57507 13.6572 10.0228 14.1049 10.5751 14.1049H11.9643C12.2404 14.1049 12.4643 13.881 12.4643 13.6049C12.4643 13.3288 12.2404 13.1049 11.9643 13.1049H10.5751V7.98291C10.5751 7.43063 10.1274 6.98291 9.57507 6.98291H8.64136Z" fill="#2856F8"/>
      </svg>
    </div>
    <div>
      <span class="text-xs text-light-mode-high-contrast font-normal">
        You’ve reached the maximum published page number of your plan <strong>(${limitedTextRender})</strong>.
      </span>
      <p class="text-blue-300 text-xs font-normal !mt-5">
        <a data-href="${pricingUrl}" class="gp-open-new-tab" target="_blank">Upgrade plan to unlock more pages</a>
      </p>
    </div>
    </div>`;
};

const templateButtonPublicPage = (hasCampaign: string, btnText: string, publicClass: string) => {
  const { limitedPublished } = usePlanPermission();

  return `<button class="${
    limitedPublished.value ? 'disabled pointer-events-none' : ''
  } publish_now !mt-4 btn btn-primary btn-default btn-block ${publicClass}" ${hasCampaign}>${btnText}</button>`;
};

export const warningConfirmPassword = () => {
  const enablePassword = useStore().state['app'].enablePassword;
  if (!enablePassword) {
    return '';
  }

  return `<div class="bg-amber-200 !p-4 rounded-sm flex items-start !mb-6">
     <img class="!mr-2" src="/editor/images/warning-password.svg" alt="">
    <div class="text-[#212121] text-sm font-normal w-[264px]">
    Page will not display correctly because your store is password protected.
    <br />
    <a class="warning-confirm_password text-blue-300 font-semibold cursor-pointer">Allow access</a> to your Shopify store.
    </div>
</div>`;
};
